// extracted by mini-css-extract-plugin
export default {"container":"TipAmountInput_container__6wO0-","emptyInput":"TipAmountInput_emptyInput__LMJtp","filledInput":"TipAmountInput_filledInput__PmGBV"};